module.exports = __webpack_public_path__ + "static/media/sure-flap.df0c604e.png";